<template>
  <div class="page">
    <div>
      <Panel
        lineColor="var(--primary-color)"
        style="margin-bottom: 0px; display: flex;"
      >
        <v-row>
          <v-col cols="12" md="3">
            <v-card outlined>
              <FormField
                class="input-empresa px-4 mt-4 mb-n3"
                v-model="searchEmpresa"
                label="Buscar"
                clearable
              />
              <v-divider />
              <v-simple-table height="60vh" style="overflow-y: auto;">
                <tbody>
                  <tr v-for="(e, i) in listaEmpresa" :key="i">
                    <td class="text-start py-2">
                      <h4>{{ e.nome }}</h4>
                      {{ fornecedoresAtivos(e) }}
                    </td>
                    <td class="text-truncate">
                      <v-icon size="18" class="mr-2" @click="editEmpresa(e)">
                        fa-edit
                      </v-icon>
                      <v-icon
                        color="error"
                        size="18"
                        class="mr-2"
                        @click="deleteEmpresa(e)"
                      >
                        fa-trash
                      </v-icon>
                      <v-icon
                        color="primario"
                        size="18"
                        @click="fornecedoresEmpresa(e)"
                      >
                        fa-search
                      </v-icon>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <template v-if="showEditEmpresa">
              <v-card outlined>
                <v-card-title>
                  <small>Editar empresa</small>
                </v-card-title>
                <v-divider class="mb-4" />
                <FormField
                  v-model="empresa.nomeEdit"
                  label="Nome"
                  class="px-4"
                />
                <FormAutoComplete
                  label="Selecione o ERP"
                  v-model="empresa.erp"
                  :options="erps"
                  class="px-4"
                />
                <h4 class="px-4 mb-2">Tags da Empresa:</h4>
                <v-simple-table
                  class="border-table mb-5"
                  v-if="empresaTags.length > 0"
                >
                  <tbody>
                    <tr v-for="(tag, i) in empresaTags" :key="i">
                      <td>
                        <v-row>
                          <v-col cols="auto" class="py-0">
                            <FormCheckbox
                              v-model="empresaTags[i].active"
                              :disabled="tag.deprecated"
                            />
                          </v-col>
                          <v-col class="pb-0">
                            <p class="mb-0 font-weight-bold">
                              {{ tag.description }}
                            </p>
                            <span>({{ tag.id }})</span>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-divider />
                <v-card-actions class="pa-4">
                  <v-spacer />
                  <FormButton
                    text="Cancelar"
                    type="error"
                    :disabled="isLoading"
                    @click="cancelEmpresa"
                  />
                  <FormButton
                    text="Salvar"
                    type="primario"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click="salvarEmpresa"
                  />
                </v-card-actions>
              </v-card>
            </template>
            <template v-if="showDeleteEmpresa">
              <v-card outlined>
                <v-card-title class="text-start">
                  <small>Excluir empresa {{ empresa.nome }}</small>
                </v-card-title>
                <v-divider class="mb-4" />
                <FormField
                  v-model="codigoTFA"
                  label="Código TFA:"
                  class="px-4 mb-n7"
                />
                <v-card-actions class="pa-4">
                  <v-spacer />
                  <FormButton
                    :text="
                      tfaAttempts < 1
                        ? 'Enviar Código TFA'
                        : `Reenviar Código TFA (tentativa ${tfaAttempts +
                            1} de ${maxAttempts})`
                    "
                    type="primario"
                    :loading="isLoading"
                    v-show="tfaAttempts < maxAttempts"
                    @click="enviarTFA"
                  />
                  <p v-if="countdown > 0">
                    Você poderá reenviar um código em {{ countdown }} segundos.
                  </p>
                  <p v-if="tfaAttempts === 5">
                    Você atingiu o limite máximo de tentativas de geração de
                    TFA.
                  </p>
                </v-card-actions>
                <v-divider />
                <v-card-actions class="pa-4">
                  <v-spacer />
                  <FormButton
                    text="Cancelar"
                    type="error"
                    :disabled="isLoading"
                    @click="cancelEmpresa"
                  />
                  <FormButton
                    text="Excluir"
                    type="error"
                    :disabled="tfaAttempts >= maxAttempts"
                    :loading="isLoading"
                    @click="excluirEmpresa"
                  />
                </v-card-actions>
              </v-card>
            </template>
            <template v-if="showFornecedoresEmpresa">
              <v-card outlined>
                <FormField
                  class="input-empresa px-4 mt-4 mb-n3"
                  v-model="searchFornecedor"
                  label="Buscar"
                  clearable
                />
                <v-divider />
                <v-simple-table height="60vh" style="overflow-y: auto;">
                  <tbody>
                    <tr v-for="(f, i) in listaFornecedores" :key="i">
                      <td class="text-start py-2">
                        <h4>{{ f.nome }}</h4>
                        <small v-if="!f.ativo">Fornecedor inativo</small>
                      </td>
                      <td class="text-truncate">
                        <v-icon
                          size="18"
                          class="mr-2"
                          @click="editFornecedor(f)"
                        >
                          fa-edit
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card>
            </template>
          </v-col>
          <v-col cols="12" md="6" v-if="showEditFornecedor" class="text-start">
            <v-card outlined>
              <v-card-title>
                Editar fornecedor
              </v-card-title>
              <v-card-text>
                <p class="mb-0">IDEMPRESA: {{ fornecedor.idempresa }}</p>
                <p class="mb-0">ID: {{ fornecedor.idfornecedor }}</p>
              </v-card-text>
              <v-card-text
                class="pa-0 ma-0"
                style="overflow-y: auto; height: 60vh;"
              >
                <v-divider class="mb-5" />
                <FormField
                  v-model="fornecedor.nome"
                  label="Nome"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.tipodocumento"
                  label="Tipo de documento"
                  placeholder="Ex: CPF, CNPJ"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.nrdocumento"
                  label="Núm. documento"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.razao_social"
                  label="Razão social"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.nome_fantansia"
                  label="Nome fantasia"
                  class="px-4"
                />
                <h4 class="px-4 mb-n3">Tipo de loja</h4>
                <v-row no-gutters class="px-4">
                  <FormCheckbox
                    class="mr-3"
                    v-for="tl in tiposLoja"
                    :key="tl.value"
                    v-model="fornecedor.tipo_loja"
                    :label="tl.text"
                    :val="tl.value"
                  />
                </v-row>
                <FormSelect
                  label="Status"
                  v-model="fornecedor.status_fornecedor"
                  :options="optionsStatus"
                  class="px-4"
                />
                <FormSelect
                  label="Segmentos de operação"
                  v-model="fornecedor.idsegmento"
                  :options="segmentos"
                  class="px-4"
                />
                <h4 class="px-4 mb-2">Tags do Fornecedor:</h4>
                <v-simple-table
                  class="border-table mb-5"
                  v-if="tags.length > 0"
                >
                  <tbody>
                    <tr v-for="(tag, i) in tags" :key="i">
                      <td>
                        <v-row>
                          <v-col cols="auto" class="py-0">
                            <FormCheckbox
                              v-model="tags[i].active"
                              :disabled="tag.deprecated"
                            />
                          </v-col>
                          <v-col class="pb-0">
                            <p class="mb-0 font-weight-bold">
                              {{ tag.description }}
                            </p>
                            <span>({{ tag.id }})</span>
                          </v-col>
                        </v-row>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <FormField
                  v-model="fornecedor.tempoentrega"
                  label="Tempo entrega"
                  class="px-4"
                  typeField="number"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.package"
                  label="Package"
                  placeholder="Package configurada no param.js do aplicativo"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.playstore"
                  label="Link white label Play Store"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.appstore"
                  label="Link white label App Store"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.app_key"
                  label="App key do OneSignal"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.api_key"
                  label="Api key do OneSignal"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.googleApiKey"
                  label="Api key do Google"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.captchaKey"
                  label="Site key do RECAPTCHA"
                  class="px-4"
                />
                <FormField
                  v-if="fornecedor.configuracao"
                  v-model="fornecedor.configuracao.captchaSecret"
                  label="Secret key do RECAPTCHA"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.grupo"
                  label="Grupo de lojas"
                  class="px-4"
                />
                <FormDatePicker
                  v-model="fornecedor.data_inicio_contrato"
                  label="Data de início do contrato"
                  class="px-4"
                />
                <FormField
                  v-model="fornecedor.configuracao.ordem_loja"
                  label="Ordenação da loja"
                  class="px-4"
                  typeField="number"
                />
                <v-card outlined>
                  <v-card-text class="d-flex">
                    <h4 style="color: black !important;">
                      Criar grupo de preço padrão
                    </h4>
                    <v-icon
                      class="ml-auto"
                      v-if="!showCards.includes(1)"
                      @click="showCards.push(1)"
                    >
                      fa-chevron-down
                    </v-icon>
                    <v-icon
                      class="ml-auto"
                      v-else
                      @click="showCards = showCards.filter(v => v != 1)"
                    >
                      fa-chevron-up
                    </v-icon>
                  </v-card-text>
                  <template v-if="showCards.includes(1)">
                    <v-divider />
                    <v-card-text>
                      Está ação irá criar o grupo de preço padrão
                    </v-card-text>
                    <v-card-actions class="pa-4">
                      <v-spacer />
                      <FormButton
                        text="Criar"
                        type="primario"
                        :loading="isLoading"
                        :disabled="!fornecedor.ativo"
                        @click="criarGrupoPreco"
                      />
                    </v-card-actions>
                  </template>
                </v-card>
                <v-card outlined>
                  <v-card-text class="d-flex">
                    <h4 style="color: black !important;">
                      Criar vínculo com Pajé e fila Pubsub
                    </h4>
                    <v-icon
                      class="ml-auto"
                      v-if="!showCards.includes(2)"
                      @click="showCards.push(2)"
                    >
                      fa-chevron-down
                    </v-icon>
                    <v-icon
                      class="ml-auto"
                      v-else
                      @click="showCards = showCards.filter(v => v != 2)"
                    >
                      fa-chevron-up
                    </v-icon>
                  </v-card-text>
                  <template v-if="showCards.includes(2)">
                    <v-divider />
                    <v-card-text>
                      <FormSelect
                        label="Versão Executável"
                        v-model="paje.executavel"
                        :options="pwc"
                      />
                      <FormSelect
                        label="Versão Pacote"
                        v-model="paje.pacote"
                        :options="pwcs"
                        class="mb-n5"
                      />
                    </v-card-text>
                    <v-card-actions class="pa-4">
                      <v-spacer />
                      <FormButton
                        text="Criar"
                        type="primario"
                        :loading="isLoading"
                        :disabled="!fornecedor.ativo"
                        @click="criarVinculoPaje"
                      />
                    </v-card-actions>
                  </template>
                </v-card>
                <v-card outlined>
                  <v-card-text class="d-flex">
                    <h4 style="color: black !important;">
                      Normalizar código interno dos produtos
                    </h4>
                    <v-icon
                      class="ml-auto"
                      v-if="!showCards.includes(3)"
                      @click="showCards.push(3)"
                    >
                      fa-chevron-down
                    </v-icon>
                    <v-icon
                      class="ml-auto"
                      v-else
                      @click="showCards = showCards.filter(v => v != 3)"
                    >
                      fa-chevron-up
                    </v-icon>
                  </v-card-text>
                  <template v-if="showCards.includes(3)">
                    <v-divider />
                    <v-card-text>
                      Está ação irá aplicar o código de barras no código interno
                      quando o produto não possuir código interno
                    </v-card-text>
                    <v-card-actions class="pa-4">
                      <v-spacer />
                      <FormButton
                        text="Normalizar"
                        type="primario"
                        :loading="isLoading"
                        :disabled="!fornecedor.ativo"
                        @click="normalizarIdErpProdutos"
                      />
                    </v-card-actions>
                  </template>
                </v-card>
                <v-card outlined>
                  <v-card-text class="d-flex">
                    <h4 style="color: black !important;">
                      Copiar preços para o paje
                    </h4>
                    <v-icon
                      class="ml-auto"
                      v-if="!showCards.includes(4)"
                      @click="showCards.push(4)"
                    >
                      fa-chevron-down
                    </v-icon>
                    <v-icon
                      class="ml-auto"
                      v-else
                      @click="showCards = showCards.filter(v => v != 4)"
                    >
                      fa-chevron-up
                    </v-icon>
                  </v-card-text>
                  <template v-if="showCards.includes(4)">
                    <v-divider />
                    <v-card-text>
                      Está ação irá copiar o preço de todos produtos da tabela
                      de preço e enviar para o Pajé <br />
                      <strong>
                        *está ação pode demorar para ser concluída*
                      </strong>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                      <v-spacer />
                      <FormButton
                        text="Copiar"
                        type="primario"
                        :loading="isLoading"
                        :disabled="!fornecedor.ativo"
                        @click="copiarPrecoPaje"
                      />
                    </v-card-actions>
                  </template>
                </v-card>
                <v-card outlined>
                  <v-card-text class="d-flex">
                    <h4 style="color: black !important;">
                      Sincronia de dados
                    </h4>
                    <v-icon
                      class="ml-auto"
                      v-if="!showCards.includes(5)"
                      @click="showCards.push(5)"
                    >
                      fa-chevron-down
                    </v-icon>
                    <v-icon
                      class="ml-auto"
                      v-else
                      @click="showCards = showCards.filter(v => v != 5)"
                    >
                      fa-chevron-up
                    </v-icon>
                  </v-card-text>
                  <template v-if="showCards.includes(5)">
                    <v-divider />
                    <v-card-text>
                      Utilize essas opções para solicitar sincronia de dados ao
                      indexador (PizzaRoll)
                    </v-card-text>
                    <FormButton
                      text="Sincronizar produtos"
                      class="mx-4 mb-2"
                      type="primario"
                      :loading="isLoading"
                      :disabled="!fornecedor.ativo"
                      @click="sincroniaProdutosIndexador"
                    />
                    <br />
                    <FormButton
                      text="Sincronizar pedidos"
                      class="mx-4 mb-2"
                      type="primario"
                      :loading="isLoading"
                      :disabled="!fornecedor.ativo"
                      @click="sincroniaPedidoIndexador"
                    />
                    <br />
                    <FormButton
                      text="Sincronizar clientes"
                      class="mx-4 mb-2"
                      type="primario"
                      :loading="isLoading"
                      :disabled="!fornecedor.ativo"
                      @click="sincroniaClienteIndexador"
                    />
                  </template>
                </v-card>
              </v-card-text>
              <v-divider />
              <v-card-actions class="pa-4">
                <v-spacer />
                <FormButton
                  text="Cancelar"
                  type="error"
                  :disabled="isLoading"
                  @click="cancelFornecedor"
                />
                <FormButton
                  text="Salvar"
                  type="primario"
                  :loading="isLoading"
                  @click="salvarFornecedor"
                  :disabled="isLoading || !fornecedor.ativo"
                />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </Panel>
    </div>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import {
  EMPRESA_LOAD_ALL,
  EMPRESA_CREATE_PRICE_GROUP,
  EMPRESA_CREATE_REMOTE_REPOSITORY,
  EMPRESA_NORMALIZE_IDERP,
  EMPRESA_COPY_PRICE,
  EMPRESA_SYNCHRONIZE_PRODUCTS,
  EMPRESA_SYNCHRONIZE_ORDERS,
  EMPRESA_SYNCHRONIZE_CLIENTS,
  EMPRESA_CREATE,
  EMPRESA_TFA,
  EMPRESA_DELETE,
  EMPRESA_LOAD_TAGS,
  ERPS
} from "@/store/actions/empresa";
import { SEGMENTO_LIST_ALL, SEGMENTO_LIST } from "@/store/actions/segmento";
import { ADMIN_LOAD_PWC, ADMIN_LOAD_PWCS } from "@/store/actions/admin";
import { PARAMETRO_LOAD_TAGS } from "@/store/actions/parametros";
import {
  GET_FORNECEDOR_DATA,
  FORNECEDOR_UPDATE
} from "@/store/actions/fornecedor";
import FormField from "@/components/form/FormField";
import FormAutoComplete from "@/components/form/FormAutocomplete";
import FormCheckbox from "@/components/form/FormCheckbox";
import FormButton from "@/components/form/FormButton";
import FormSelect from "@/components/form/FormSelect";
import FormDatePicker from "@/components/form/FormDatePicker";

export default {
  name: "EmpresaAdmin",
  components: {
    Panel,
    FormField,
    FormAutoComplete,
    FormButton,
    FormCheckbox,
    FormSelect,
    FormDatePicker
  },
  data: () => ({
    isLoading: false,
    searchEmpresa: "",
    searchFornecedor: "",
    erps: ERPS,
    empresas: [],
    empresa: {},
    showEditEmpresa: false,
    showDeleteEmpresa: false,
    showFornecedoresEmpresa: false,
    showEditFornecedor: false,
    showCards: [],
    fornecedor: {},
    segmentos: [],
    pwc: [],
    pwcs: [],
    tags: [],
    empresaTags: [],
    paje: {},
    optionsStatus: [
      { value: "PRODUCAO", text: "Produção" },
      { value: "IMPLANTACAO", text: "Implantação" },
      { value: "SUSPENSO", text: "Suspenso" },
      { value: "CANCELADO", text: "Cancelado" },
      { value: "BLOQUEADO", text: "Bloqueado" }
    ],
    tiposLoja: [
      { value: "B2B", text: "B2B" },
      { value: "B2C", text: "B2C" }
    ],
    codigoTFA: "",
    disableSendTFA: false,
    countdown: 0,
    tfaAttempts: 0,
    maxAttempts: 5
  }),
  computed: {
    listaEmpresa() {
      const search = (this.searchEmpresa || "").toUpperCase();
      return (this.empresas || []).filter(e =>
        e.nome.toUpperCase().includes(search.toUpperCase())
      );
    },
    listaFornecedores() {
      const search = (this.searchFornecedor || "").toUpperCase();
      return (this.empresa.fornecedores || []).filter(f =>
        f.nome.toUpperCase().includes(search.toUpperCase())
      );
    }
  },
  methods: {
    getEmpresas(clear = false) {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_LOAD_ALL)
        .then(data => {
          this.empresas = (data || []).sort((a, b) => {
            return a.nome.localeCompare(b.nome);
          });
          if (clear) {
            this.cancelEmpresa();
          } else {
            const empresa = this.empresas.filter(
              e => e.idempresa == this.empresa.idempresa
            )[0];
            this.showFornecedoresEmpresa = false;
            this.fornecedoresEmpresa(empresa);
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao listar as empresas");
          this.isLoading = false;
        });
    },
    getFornecedor(fornecedor) {
      this.isLoading = true;
      this.$store
        .dispatch(GET_FORNECEDOR_DATA, fornecedor.idfornecedor)
        .then(data => {
          this.fornecedor = { ...data, ativo: fornecedor.ativo };

          this.fornecedor.tipo_loja =
            this.fornecedor.tipo_loja &&
            Array.isArray(this.fornecedor.tipo_loja)
              ? this.fornecedor.tipo_loja
              : [];
          this.getSegmento(fornecedor.idfornecedor);
          this.getTags(fornecedor.idfornecedor);
          this.isLoading = false;
        });
    },
    getSegmentos() {
      this.isLoading = true;
      this.$store.dispatch(SEGMENTO_LIST_ALL, null).then(data => {
        this.segmentos = (data || []).map(s => {
          return {
            text: s.nome,
            value: s.idsegmento
          };
        });
        this.isLoading = false;
      });
    },
    getSegmento(idfornecedor) {
      this.isLoading = true;
      this.$store.dispatch(SEGMENTO_LIST, idfornecedor).then(data => {
        if (data && data.length > 0) {
          this.fornecedor.idsegmento = data[0].idsegmento;
        }
        this.isLoading = false;
      });
    },
    getPWC() {
      this.isLoading = true;
      this.$store.dispatch(ADMIN_LOAD_PWC, {}).then(data => {
        this.pwc = (data.lista || []).map(item => ({
          text: item,
          value: item
        }));
        this.isLoading = false;
      });
    },
    getPWCS() {
      this.isLoading = true;
      this.$store.dispatch(ADMIN_LOAD_PWCS, {}).then(data => {
        this.pwcs = (data.lista || []).map(item => ({
          text: item,
          value: item
        }));
        this.isLoading = false;
      });
    },
    getTags(idfornecedor) {
      this.isLoading = true;
      this.$store
        .dispatch(PARAMETRO_LOAD_TAGS, {
          onlyAdmin: "",
          onlyAdvancedMaintenance: "",
          idfornecedor
        })
        .then(data => {
          this.tags = data || [];
          this.isLoading = false;
        });
    },
    fornecedoresAtivos(empresa) {
      const fornecedores = empresa.fornecedores || [];
      const ativos = fornecedores.filter(f => f.ativo) || [];
      return `${ativos.length} \\ ${fornecedores.length} fornecedores ativos`;
    },
    editEmpresa(empresa) {
      this.showFornecedoresEmpresa = false;
      this.showDeleteEmpresa = false;
      this.showEditFornecedor = false;
      this.showEditEmpresa = true;
      this.empresa = { ...empresa, nomeEdit: empresa.nome };
      this.getEmpresaTags(empresa.idempresa);
    },
    deleteEmpresa(empresa) {
      this.showFornecedoresEmpresa = false;
      this.showEditEmpresa = false;
      this.showDeleteEmpresa = true;
      this.empresa = empresa;
    },
    fornecedoresEmpresa(empresa) {
      this.showEditEmpresa = false;
      this.showDeleteEmpresa = false;
      this.showEditFornecedor = false;
      this.showFornecedoresEmpresa = true;
      this.empresa = empresa;
    },
    getEmpresaTags(idempresa) {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_LOAD_TAGS, {
          idempresa: idempresa
        })
        .then(data => {
          this.empresaTags = data || [];
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    cancelEmpresa() {
      this.segmentos = [];
      this.pwc = [];
      this.pwcs = [];
      this.tags = [];
      this.empresaTags = [];
      this.showEditEmpresa = false;
      this.showFornecedoresEmpresa = false;
      this.showEditFornecedor = false;
      this.empresa = {};
      this.fornecedor = {};
    },
    cancelFornecedor() {
      this.segmentos = [];
      this.pwc = [];
      this.pwcs = [];
      this.tags = [];
      this.showEditFornecedor = false;
      this.fornecedor = {};
    },
    salvarEmpresa() {
      const tags = this.empresaTags.filter(t => t.active).map(t => t.id);

      const data = {
        idempresa: this.empresa.idempresa,
        nome: this.empresa.nomeEdit,
        tags: tags,
        erp: this.empresa.erp
      };
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_CREATE, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Empresa atualizada com sucesso");
          this.getEmpresas(true);
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao atualizar a empresa");
          this.isLoading = false;
        });
    },
    enviarTFA() {
      if (this.tfaAttempts === this.maxAttempts) {
        this.$vueOnToast.pop("error", "Limite Máximo de tentativas atingidos");
        return;
      }
      const data = {
        idempresa: this.empresa.idempresa
      };
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_TFA, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Código TFA enviado com sucesso");
          this.isLoading = false;
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err || "Falha ao enviar código TFA");
          this.isLoading = false;
        });
      this.disableSendTFA = true;
      this.countdown = 10;
      const countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(countdownInterval);
          this.tfaAttempts++;
          if (this.tfaAttempts < this.maxAttempts) {
            this.disableSendTFA = false;
          }
        }
      }, 1000);
    },
    excluirEmpresa() {
      const data = {
        idempresa: this.empresa.idempresa,
        codigoTFA: this.codigoTFA
      };
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_DELETE, data)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            `Exclusão da empresa ${this.empresa.nome} iniciada com sucesso! O administrador receberá um e-mail com o resultado da operação.`
          );
          this.isLoading = false;
        })
        .catch(err => {
          this.$vueOnToast.pop("error", err || "Falha ao excluir empresa");
          this.tfaAttempts++;
          if (this.tfaAttempts < this.maxAttempts) {
            this.disableSendTFA = false;
          }
          this.isLoading = false;
        });
    },
    editFornecedor(fornecedor) {
      this.getSegmentos();
      this.getFornecedor(fornecedor);
      this.getPWC();
      this.getPWCS();
      this.showEditFornecedor = true;
    },
    criarGrupoPreco() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_CREATE_PRICE_GROUP, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop("success", "Grupo de preço criado com sucesso");
          this.isLoading = false;
        })
        .catch(err => {
          const erro = err || "Falha ao tentar criar vínculo com paje";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    criarVinculoPaje() {
      if (!this.paje.pacote) {
        this.$vueOnToast.pop("error", "Versão do pacote é obrigatória!");
        return;
      }
      if (!this.paje.executavel) {
        this.$vueOnToast.pop("error", "Versão do executável é obrigatória!");
        return;
      }
      if (
        this.extrairNumero(this.paje.pacote) !=
        this.extrairNumero(this.paje.executavel)
      ) {
        this.$vueOnToast.pop(
          "error",
          "Versão do executável não é compatível com o pacote!"
        );
        return;
      }
      this.isLoading = true;
      const data = {
        idfornecedor: this.fornecedor.idfornecedor,
        pacote: this.paje.pacote,
        executavel: this.paje.executavel
      };
      this.$store
        .dispatch(EMPRESA_CREATE_REMOTE_REPOSITORY, data)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Vículo com o Pajé e fila Pubsub criados com sucesso"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message ||
            "Falha ao criar vículo com o Pajé ou fila Pubsub";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    extrairNumero(string) {
      const numeros = string.match(/\d+/);
      if (numeros && numeros.length > 0) {
        return parseInt(numeros[0], 10);
      }
      return null;
    },
    normalizarIdErpProdutos() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_NORMALIZE_IDERP, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Processamento de produtos terminado com sucesso"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message || "Falha ao tentar processar os produto";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    copiarPrecoPaje() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_COPY_PRICE, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Processamento de preços terminado com sucesso"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message ||
            "Falha ao tentar processar os preços de produto";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    sincroniaProdutosIndexador() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_SYNCHRONIZE_PRODUCTS, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Sincronia de produtos enviada ao indexador"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message ||
            "Falha ao enviar sincronia de produtos ao indexador";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    sincroniaPedidoIndexador() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_SYNCHRONIZE_ORDERS, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Sincronia de pedidos enviada ao indexador"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message ||
            "Falha ao enviar sincronia de pedidos ao indexador";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    sincroniaClienteIndexador() {
      this.isLoading = true;
      this.$store
        .dispatch(EMPRESA_SYNCHRONIZE_CLIENTS, this.fornecedor.idfornecedor)
        .then(() => {
          this.$vueOnToast.pop(
            "success",
            "Sincronia de clientes enviada ao indexador"
          );
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message ||
            "Falha ao enviar sincronia de clientes ao indexador";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    salvarFornecedor() {
      const tags = this.tags
        .filter(t => {
          return t.active;
        })
        .map(t => {
          return t.id;
        });
      const data = {
        ...this.fornecedor,
        segmentos: [this.fornecedor.idsegmento],
        tipoLoja: this.fornecedor.tipo_loja,
        banco: { id: null },
        tags: tags,
        ...this.fornecedor.configuracao
      };
      const erro = this.validarDadosFornecedor(data);
      if (erro) {
        this.$vueOnToast.pop("error", erro);
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch(FORNECEDOR_UPDATE, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Fornecedor atualizado com sucesso");
          this.getEmpresas(false);
          this.isLoading = false;
        })
        .catch(err => {
          const erro =
            err.responseJSON.message || "Falha ao atualizar fornecedor";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    validarDadosFornecedor(data) {
      if (!data.nome || data.nome.length < 3) {
        return "Informe nome do fornecedor.";
      }
      if (!data.tipodocumento || !data.nrdocumento) {
        return "Informe um documento (tipo e número).";
      }
      if ((data.segmentos || []).length === 0) {
        return "Vincule este fornecedor à pelo menos um segmento.";
      }
      if (!data.grupo) {
        return "Informe o grupo do fornecedor.";
      }
      if (!data.razao_social) {
        return "Informe a razão social";
      }
      if (!data.nome_fantansia) {
        return "Informe o nome fantasia do fornecedor";
      }
      if (!data.tipoLoja || !data.tipoLoja.length) {
        return "Informe um tipo de loja";
      }
      if (!data.status_fornecedor) {
        return "Informe o status do fornecedor";
      }
      if (!data.data_inicio_contrato) {
        return "Informe uma data de início de contrato válida.";
      }
      return null;
    }
  },
  created() {
    this.getEmpresas(true);
  }
};
</script>

<style>
.border-table {
  border: 1px solid #ccc;
}
</style>
